import React from "react";
import { motion, AnimatePresence, MotionConfig } from "framer-motion";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import AboutUs from "./components/AboutUs";
import ContactUs from "./components/ContactUs";
import Footer from "./components/Footer";
import ParticlesBackground from "./components/ParticlesBackground";
import { ThemeProvider } from "./context/ThemeContext";
import { springSnappy, pageOrchestrator, pageChild } from "./utils/animations";
import "./i18n";

export default function App() {
  return (
    <ThemeProvider>
      <MotionConfig transition={springSnappy}>
        <div className="relative bg-white dark:bg-main min-h-screen font-cairo transition-colors duration-300 gradient-mesh">
          <ParticlesBackground />
          <AnimatePresence mode="wait">
            <motion.div
              key="page"
              variants={pageOrchestrator}
              initial="hidden"
              animate="visible"
              className="relative z-10"
            >
              <Navbar />
              <motion.div variants={pageChild}><Hero /></motion.div>
              <motion.div variants={pageChild}><Services /></motion.div>
              <motion.div variants={pageChild}><AboutUs /></motion.div>
              <motion.div variants={pageChild}><ContactUs /></motion.div>
              <motion.div variants={pageChild}><Footer /></motion.div>
            </motion.div>
          </AnimatePresence>
        </div>
      </MotionConfig>
    </ThemeProvider>
  );
}
